import { useIonToast } from '@ionic/react';
import { useInstance } from '../../support/ioc/useInstance';
import { ToastPresenter } from './ToastPresenter.ts';
import './ToastBinder.css';

export const ToastBinder = () => {
    const presenter = useInstance(ToastPresenter);
    const [showToast] = useIonToast();
    presenter._setToastMethods({ showToast });
    return null;
};
